import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { HeaderService } from "src/app/_services/header.service";
import { UserService } from "../../_services";
import { ThisPlatform } from "../../_services/platform.service";
import { RowsLoaderService } from "../../_services/rows-loader.service";
import { SpaceType } from "../../_types/space-type";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { EditEquipmentComponent } from "./edit-equipment/edit-equipment.component";
import { EquipmentViewComponent } from "./equipment-view/equipment-view.component";
import { Equipment } from "./equipment.model";
import { EquipmentService } from "./equipment.service";
@Component({
  selector: "app-equipment",
  templateUrl: "./equipment.page.html",
  styleUrls: ["./equipment.page.scss"],
})
export class EquipmentPage implements OnInit {
  constructor(
    public equipmentServ: EquipmentService,
    public userServ: UserService,
    public p: ThisPlatform,
    public modalCtrl: ModalController,
    private route: ActivatedRoute,
    private location: Location,
    private headerServ: HeaderService,
  ) {}

  componentRef: any = EquipmentViewComponent;
  spaceType: SpaceType;
  equipments: Equipment[] = [];
  equipmentsFilter: Equipment[] = [];
  equipmentAddRole;
  filterString: string;
  columnsDefinition: PaginationColumn[] = [
    {
      name: "icon",
      displayName: "EQUIPMENT.ICON",
      size: 2,
      sortable: false,
    },
    {
      name: "name",
      displayName: "NAME",
      size: 10,
      sortable: true,
      colValue: (row) => {
        return row.name;
      },
    },
  ];

  rowsLoader: RowsLoaderService;

  async ngOnInit() {
    this.equipmentAddRole = await this.userServ.hasRolesAsync(["equipment.add"]);
    
    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has("spaceType")) {
        this.location.back();
        return;
      }
      
      this.spaceType = Number(paramMap.get("spaceType"));
    });
  }
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit({
      title: "EQUIPMENT.NAME",
    });
    this.refreshEquipments();
  }

  refreshEquipments() {
    this.equipmentServ
      .getEquipments(this.spaceType)
      .subscribe((res: Equipment[]) => {
        this.equipments = res;
        this.equipmentsFilter = res;
        this.rowsLoaderInit();
      });
  }

  rowsLoaderInit() {
    if(this.filterString) {
      this.equipmentsFilter = this.equipments.filter((s) =>
      s.name.toUpperCase().includes(this.filterString.toUpperCase())
      );
    } else {
      this.equipmentsFilter = this.equipments
    }
    if (this.rowsLoader) {
      this.rowsLoader.init(this.equipmentsFilter);
    }
  }

  onChangeSearch(data) {
    this.filterString = data
    this.rowsLoaderInit();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  handleActionRequest(action) {
    if (action.type === "edit") {
      this.onEditEquipment(action.id); //(action.id);
    }
  }

  async onEditEquipment(id: number) {
    const modal = await this.modalCtrl.create({
      component: EditEquipmentComponent,
      animated: true,
      cssClass: "add-edit-modal",
      componentProps: {
        idEquipment: id,
        spaceType: this.spaceType,
      },
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      this.refreshEquipments();
      if (data.data) {
      }
    });
  }
}
